<template>
  <v-app>
    <AppBar />
    <SpinnerOverlay v-if="busy" />
    <v-container style="max-width:980px;">
      <v-main>
        <AccountInvoiceDetail
            :invoice="invoice"
            :account="account"
            :amount="amount"
            @valid="accountValid"
            @invalid="accountInvalid"
            v-if="!paymentSuccess"
        />
        <PaymentDetails
                @valid="cardValid"
                @invalid="cardInvalid"
                v-if="!paymentSuccess"
        />
        <v-row v-if="!paymentSuccess">
          <v-col cols="12" class="text-center pt-6">
            <p class="subtitle-1">Please confirm you are not a robot. Bleep bloop.</p>
          </v-col>
          <v-col cols="12" align="center">
            <vue-recaptcha
                    ref="captcha"
                    :sitekey="recaptcha.sitekey"
                    :loadRecaptchaScript="true"
                    @verify="recaptchaVerified"
                    @expired="recaptchaExpired"
            ></vue-recaptcha>
          </v-col>
        </v-row>
        <v-row v-if="error">
          <v-col cols="12">
            <v-alert
                    type="error"
                    prominent
            >
              <v-row align="center">
                <v-col class="grow">
                  {{error}}
                </v-col>
                <v-col class="shrink">
                  <v-btn icon @click="error=null"><v-icon>mdi-close</v-icon></v-btn>
                </v-col>
              </v-row>

            </v-alert>
          </v-col>
        </v-row>
        <v-row v-if="!paymentSuccess">
          <v-col cols="12">
            <v-btn
                    x-large
                    class="primary"
                    block
                    :disabled="!formValid"
                    @click="submit"
            >Pay Now</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="paymentSuccess">
          <v-col cols="12">
            <v-alert type="success">Your payment was processed successfully!</v-alert>
          </v-col>
        </v-row>
        <v-row v-if="paymentSuccess" dense>
          <v-col cols="6">
            <span class="font-weight-bold">Amount Paid</span>
          </v-col>
          <v-col cols="6">
            ${{accountData.paymentAmount}}
          </v-col>
          <v-col cols="6">
            <span class="font-weight-bold">Breeze Connect Account No</span>
          </v-col>
          <v-col cols="6">
            {{accountData.account}}
          </v-col>
          <v-col cols="6">
            <span class="font-weight-bold">Breeze Connect Payment Ref</span>
          </v-col>
          <v-col cols="6">
            {{result.ref}}
          </v-col>
          <v-col cols="6">
            <span class="font-weight-bold">Transaction ID</span>
          </v-col>
          <v-col cols="6">
            {{result.id}}
          </v-col>
        </v-row>
        <v-row v-if="paymentSuccess">
          <v-col>
            <p class="subtitle-2">Your account balance will be updated within an hour. If your account was suspended due to an outstanding balance which has now been paid in full then it will be lifted automatically.</p>
          </v-col>
        </v-row>
        <Footer />
      </v-main>
    </v-container>
  </v-app>
</template>

<script>
import AppBar from "./components/AppBar";
import Footer from "./components/Footer";
import AccountInvoiceDetail from "./components/AccountInvoiceDetail";
import SpinnerOverlay from "./components/SpinnerOverlay";
import PaymentDetails from "./components/PaymentDetails";
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios';

export default {
    name: 'App',
    methods: {
        cardValid(data) {
          this.cardData = data;
          this.cardDataValid = true;
        },
      cardInvalid() {
          this.cardData = {};
        this.cardDataValid = false;
      },
      accountValid(data) {
          this.accountData = data;
        this.accountDataValid = true;
      },
      accountInvalid() {
          this.accountData = {};
        this.accountDataValid = false;
      },
        recaptchaVerified(response) {
          this.error = null;
          this.recaptcha.result = response;
          this.recaptcha.valid = true;
        },
        recaptchaExpired() {
          this.recaptcha.result = null;
          this.recaptcha.valid = false;
        },
      async submit() {
        this.busy = true;

        const baseUrl = process.env.VUE_APP_API_BASE;
        var params = {
          name: this.cardData.name,
          cc: this.cardData.cc,
          cvv: this.cardData.cvv,
          month: this.cardData.month,
          year: this.cardData.year,
          invoice: this.accountData.invoice,
          account: this.accountData.account,
          amount: this.accountData.paymentAmount,
          recaptcha_response: this.recaptcha.result
        };

        try {
          let response = await axios.post(baseUrl + 'v1/paymybill', params);
          this.paymentSuccess = true;
          this.result.id = response.data.transaction_id;
          this.result.ref = response.data.payment_ref;

          this.cancelBusy();
        } catch (err) {
          if (err.response) {
            this.error = err.response.data.description;
          } else {
            this.error = "An unknown error occurred";
          }
          this.cancelBusy();
        }
      },
      cancelBusy() {
        this.$nextTick();
        this.recaptcha.valid = false;
        this.$refs['captcha'].reset();
        this.busy = false;
      },
    },
    components: {
        PaymentDetails,
        SpinnerOverlay,
        AccountInvoiceDetail,
        Footer,
        AppBar,
      VueRecaptcha
    },

    data: () => ({
        busy: false,
        invoice: null,
        account: null,
        amount: null,
        recaptcha: {
          sitekey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
          result: null,
          valid: false
        },
        cardDataValid: false,
        accountDataValid: false,
        paymentSuccess: false,
        accountData: {},
        cardData: {},
      result: {
          ref: null,
        id: null
      },
      error: null
    }),
    computed: {
        formValid: function() {
          return (this.cardDataValid && this.accountDataValid && this.recaptcha.valid);
        }
    },
    created() {
        // check for get params and pre-fill variables if present
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get('inv')) {
            this.invoice = parseInt(urlParams.get('inv'));
        }
        if (urlParams.get('acc')) {
            this.account = parseInt(urlParams.get('acc'));
        }
        if (urlParams.get('amt')) {
          this.amount = parseFloat(urlParams.get('amt')).toFixed(2);
        }
    }
};
</script>
